import 'svgxuse';
import './helpers/_service';
import './modules/run';

console.log("something...!");
